const DUTCH = ["dutch", "nl", "netherlands", "nederland", "holland", "the netherlands"];
const FRENCH = ["french", "fr", "france", "frankreich"];
const GERMAN = [
  "german", "de", "at", "ch", "lu",
  "germany", "deutschland",
  "austria", "österreich", "oesterreich",
  "switzerland", "schweiz",
  "luxembourg", "luxemburg",
];

export const getFormLanguage = (language) => {
  if (!language || typeof language !== "string") return "english";

  const c = language.toLowerCase().trim();
  if (!c) return "english";

  if (DUTCH.some((k) => c === k || c.includes(k))) return "dutch";
  if (FRENCH.some((k) => c === k || c.includes(k))) return "french";
  if (GERMAN.some((k) => c === k || c.includes(k))) return "german";

  return "english";
};
